import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: 'manager/schedules',
  urlRoot: 'manager/schedules'
})
